import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'

import { Box, Button, Icon, Image, Text, Link } from '@redriverpress/system'

import Clipboard from 'Images/onb-terms_conditions.svg'
import CheckboxField from 'Common/components/forms/CheckboxField'
import Loc from '../common/components/Loc'

import { useStudentOnboardingContext } from '../context/onboardingStudentContext'
import { SOCIAL_SSO, STD_ONBOARDING_PATH } from '../common/constants'

export default function TermsAndConditions() {
  const history = useHistory()
  const [
    { locale, socialSso, googleSsoUrl, cleverSsoUrl, classCode, isInvitation },
  ] = useStudentOnboardingContext()

  const schema = Yup.object().shape({
    acceptedTerms: Yup.boolean()
      .required()
      .oneOf([true], 'You must accept the terms'),
  })

  const getSocialUrl = () => {
    if (socialSso === SOCIAL_SSO.google) return googleSsoUrl
    if (socialSso === SOCIAL_SSO.clever) return cleverSsoUrl
  }

  const checkClassCode = () => {
    if (socialSso)
      return getSocialUrl().includes('class_code')
        ? ''
        : `&class_code=${classCode}`
    return null
  }

  useEffect(() => {
    if (!socialSso) history.push({ pathname: STD_ONBOARDING_PATH.signup })
  }, [])

  return (
    <Box
      display='flex'
      flexDirection='column'
      alignItems='center'
      minHeight='90vh'
    >
      <Box display='flex' flexDirection='column' alignItems='center'>
        <Image
          alt='Clipboard'
          src={Clipboard}
          height={['90px', null, null, '150px']}
          mb={[3, null, null, 2]}
        />
        <Text
          fontSize={[3, null, 4, 5]}
          fontWeight='600'
          letterSpacing='compressed'
          textAlign='center'
        >
          Terms and Conditions
        </Text>
        {!!locale && (
          <Loc
            fontSize={2}
            color='gray700'
            fontWeight='600'
            copy='Terms and Conditions'
          />
        )}
      </Box>

      <Formik
        initialValues={{ acceptedTerms: false }}
        validationSchema={schema}
        style={{ display: 'flex', flex: '1' }}
      >
        {formik => {
          const { values } = formik

          return (
            <Form
              style={{
                display: 'flex',
                flex: '1',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center',
              }}
            >
              <Box mt={3} width={[null, null, '70%', '50%']}>
                <Box bg='blue100' borderRadius='rounded' display='flex' p={3}>
                  <Box as='label'>
                    <CheckboxField name='acceptedTerms' />
                  </Box>
                  <Box as='label' htmlFor='acceptedTerms' ml={3} flex='1'>
                    <Text fontSize={1}>
                      I agree to Ellii’s terms and privacy policy.{' '}
                      <Link
                        color='black'
                        href='/students/terms'
                        target='_blank'
                      >
                        {' '}
                        View the Privacy Policy and Terms
                      </Link>
                      .
                    </Text>
                  </Box>
                </Box>
                {!!locale && (
                  <Loc
                    fontSize={0}
                    color='gray700'
                    fontWeight='400'
                    copy='I agree to Ellii’s terms'
                  />
                )}
              </Box>

              <Box
                width={1}
                mt='auto'
                mb={4}
                display='flex'
                justifyContent='flex-end'
              >
                {!isInvitation && (
                  <Button
                    type='button'
                    role='link'
                    mr={[2, null, 3]}
                    onClick={() =>
                      history.push({
                        pathname: `${STD_ONBOARDING_PATH.signup}/enter-class-code`,
                      })
                    }
                    secondary
                    adaptive
                  >
                    <Icon mr={2} icon='arrow-left' />
                    Back
                  </Button>
                )}
                <Button
                  as={!values.acceptedTerms ? 'button' : 'a'}
                  href={`${
                    !values.acceptedTerms ? null : getSocialUrl()
                  }&origin=sign_up${checkClassCode()}`}
                  disabled={!socialSso && !values.acceptedTerms}
                  adaptive
                >
                  Join class
                  <Icon ml={2} icon='arrow-right' />
                </Button>
              </Box>
            </Form>
          )
        }}
      </Formik>
    </Box>
  )
}
